import React from 'react';

import Alerts from './components/Alerts';

import { Helmet } from 'react-helmet';

class SignUp extends React.Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>Sign Up for Property Alerts - Partners Real Estate</title>
                </Helmet>

                <Alerts />
            </>
        );
    }
}

export default SignUp;
